<template>
  <div class="service-detail">
    <h3>服务编辑</h3>
    <el-form :model="serviceInfo" :rules="rules" ref="serviceInfo" class="demo-form-inline" size="mini"
      label-width="180px">
      <el-form-item label="服务封面">
        <!-- action="https://upload.qbox.me/" -->
        <el-form-item>
          <el-upload class="upload-demo" action="https://up-z1.qbox.me/" :on-preview="handlePreview"
            :on-remove="handleRemove" :file-list="fileList" list-type="picture-card" :on-success="handleSuccess"
            :before-upload="beforeUpload" accept="image/png, image/jpeg,image/bmp,image/gif,image/jpeg"
            :data="uploadData">
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form-item>
      <el-form-item label="类目一级" prop="jobCate">
        <el-select :disabled="serviceInfo.chargingWay == 1" v-model="serviceInfo.jobCate" value-key="id"
          placeholder="请选择" @change="cateChange('jobCate')">
          <el-option v-for="item in firstCates" :key="item.id" :label="item.name" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类目二级" prop="skillTags">
        <el-select :disabled="serviceInfo.chargingWay == 1" v-model="serviceInfo.skillTags" :multiple-limit="1"
          value-key="id" placeholder="请选择" @change="cateChange('skillTags')">
          <el-option v-for="item in secondCates" :key="item.id" :label="item.name" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类目三级" prop="thirdSkillTags">
        <el-select :disabled="serviceInfo.chargingWay == 1" @change="cateChange1($event)"
          v-model="serviceInfo.thirdSkillTags" value-key="id" multiple placeholder="请选择">
          <el-option v-for="item in thirdCates" :key="item.id" :label="item.name" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计费方式" prop="chargingWay">
        <el-select :disabled="true" v-model="serviceInfo.chargingWay" value-key="id"
          placeholder="请选择">
          <el-option v-for="item in billingMethod" :key="item.id" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务标题" prop="serviceTitle">
        <el-input type="text" v-model="serviceInfo.serviceTitle"></el-input>
      </el-form-item>
      <el-form-item label="服务详情" prop="serviceContent">
        <el-input type="textarea" rows="2" v-model="serviceInfo.serviceContent"></el-input>
      </el-form-item>

      <el-form-item :disabled="serviceInfo.chargingWay == 1" v-for="(item, index) in serviceInfo.deliverable"
        :label="'交付物' + (Number(index) + 1)" :key="index" :prop="'deliverable.' + index + '.name'" :rules="{
          required: true,
          message: '交付物不能为空',
          trigger: 'blur',
        }">
        <div style="display: flex;flex-direction: row;align-items: center;">
          <el-input :disabled="serviceInfo.chargingWay == 1" v-model="item.name"></el-input>
          <el-button @click.prevent="removeDescribe(item)" v-if="serviceInfo.chargingWay != 1">删除</el-button>
        </div>
      </el-form-item>
      <el-form-item v-if="
        serviceInfo.deliverable.length < 10 && serviceInfo.chargingWay != 1
      ">
        <el-button type="text" @click="addDeliverable">添加交付物</el-button>
      </el-form-item>
      <el-form-item label="需要客户提供的材料" prop="customerNeeds" v-if="serviceInfo.chargingWay != 1">
        <el-input type="textarea" rows="2" v-model="serviceInfo.customerNeeds"></el-input>
      </el-form-item>
      <el-form-item label="时薪（元）" prop="hourlyRate" v-if="serviceInfo.chargingWay != 1">
        <el-input v-model.number="serviceInfo.hourlyRate"></el-input>
      </el-form-item>

      <template v-if="serviceInfo.chargingWay == 1">
        <el-form-item label="标准版价格（元）" v-if="serviceInfo.versions[0]">
          <el-input :disabled="serviceInfo.chargingWay == 1" v-model.number="serviceInfo.versions[0].price"></el-input>
        </el-form-item>
        <el-form-item label="升级版价格（元）" v-if="serviceInfo.versions[1]">
          <el-input :disabled="serviceInfo.chargingWay == 1" v-model.number="serviceInfo.versions[1].price"></el-input>
        </el-form-item>
        <el-form-item label="高级版价格（元）" v-if="serviceInfo.versions[2]">
          <el-input :disabled="serviceInfo.chargingWay == 1" v-model.number="serviceInfo.versions[2].price"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="用户 ID" prop="talentId">
        <el-input :disabled="serviceInfo.chargingWay == 1 || id" type="text" v-model="serviceInfo.talentId"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import api from "../api";
const { service } = api;

export default {
  name: "jobDetail",
  data() {
    return {
      customTags: [],
      cates: [],
      billingMethod: [
        {
          label: "按时计费",
          value: 0,
        },
        {
          label: "按件计费",
          value: 1,
        },
      ],
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },

      serviceInfo: {
        serviceTitle: "",
        name: "",
        // status: 1,
        serviceContent: "",
        customerNeeds: "",
        jobName: "",
        hourlyRate: "",
        chargingWay: 0,
        cover: "",
        versions: [],
        deliverable: [
          {
            name: "",
            type: 2,
          },
        ],
        jobCate: {
          id: "",
          name: "",
        },
        skillTags:{},
        thirdSkillTags: [],
        customTags: [],
        talentId: "",
      },
      rules: {
        talentId: [
          {
            required: true,
            message: "请输用户 ID",
            trigger: "blur",
          },
        ],

        hourlyRate: [
          {
            required: true,
            message: "请输入时薪（元）",
            trigger: "blur",
          },
          {
            validator: this.hourAmount,
            trigger: "blur",
          },
        ],

        serviceTitle: [
          {
            required: true,
            message: "请输入服务标题",
            trigger: "blur",
          },
          {
            min: 5,
            max: 70,
            message: "长度在 5 到 70 个字符",
            trigger: "blur",
          },
        ],

        serviceContent: [
          {
            required: true,
            message: "请选择输入服务详情",
          },
          {
            min: 30,
            max: 1500,
            message: "长度在 30 到 1500 个字符",
            trigger: "blur",
          },
        ],

        customerNeeds: [
          {
            required: true,
            message: "需要客户提供的材料",
          },
          {
            min: 10,
            max: 1500,
            message: "长度在 10 到 1500 个字符",
            trigger: "blur",
          },
        ],

        jobCate: [
          {
            required: true,
            message: "请选择类目一级",
          },
        ],
        skillTags: [
          {
            required: true,
            message: "请选择所属行业",
          },
        ],

        thirdSkillTags: [{
            required: true,
            message: '请选择类目三级',
        }],
      },
      fileList: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    firstCates() {
      return this.getCatesById(0);
    },
    secondCates() {
      return this.serviceInfo.jobCate.id
        ? this.getCatesById(this.serviceInfo.jobCate.id)
        : [];
    },
    thirdCates() {
      return this.serviceInfo.skillTags.id
        ? this.getCatesById(this.serviceInfo.skillTags.id)
        : [];
    },
    action() {
      return this.id ? "update" : "insert";
    },
  },
  watch: {},
  mounted() {
    if (this.id) {
      this.getDetail();
    }
    this.getAllTags();
    this.getToken();
  },
  methods: {
    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    handleSuccess(res, file) {
      var url = `https:\/\/image.duiyou360.com/${res.key}`;
      // console.log(url, "上传成功--");
      var obj = {
        name: file.name,
        type: file.type,
        size: file.size,
        url: url,
      }
      this.fileList.push(obj);
      if (!this.serviceInfo.cover) {
        this.setCover(this.fileList[0].url);
      }
    },
    setCover(url) {
      this.serviceInfo.cover = url;
    },
    formatImgs(arr) {
      let newArr = [];
      console.log(arr)
      if (arr.length > 0) {
        arr.forEach((item) => {
          console.log(item.url)
          if (item.url != this.serviceInfo.cover) {
            newArr.push(item.url);
          }
        });
      }
      return newArr;
    },
    beforeUpload(file) {
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;
      let type = [
        "image/bmp",
        "image/gif",
        "image/jpg",
        "image/jpeg",
        "image/png",
      ];

      if (type.indexOf(file.type) == -1) {
        this.$message.error("上传图片支持bmp，gif，jpg，jpeg，png格式");
        return false;
      }
    },
    handleRemove(file, fileList) {
      this.fileList=fileList
      if (file.url == this.serviceInfo.cover) this.setCover(this.fileList[0].url );
    },

    handlePreview(file) {
      console.log(file);
    },
    removeDescribe(item) {
      var index = this.serviceInfo.deliverable.indexOf(item);
      if (index !== -1) {
        this.serviceInfo.deliverable.splice(index, 1);
      }
    },
    addDeliverable() {
      this.serviceInfo.deliverable.push({
        name: "",
        type: 2,
      });
    },
    hourAmount(rule, value, callback) {
      // 检查是否为整数
      const intValue = Number(value);
      if (!Number.isInteger(intValue)) {
        return callback(new Error("时薪（元）必须为整数"));
      }
      if (intValue > 1000) {
        return callback(new Error("时薪不能超过1000 "));
      }
      callback();
    },
    traditionAmount(rule, value, callback) {
      // 检查是否为整数
      const intValue = Number(value);
      if (!Number.isInteger(intValue)) {
        return callback(new Error("传统招聘月薪必须为整数"));
      }

      // 检查范围
      if (intValue < 1) {
        return callback(new Error("传统招聘月薪不能小于1元"));
      }
      if (intValue < this.monthlyRate) {
        return callback(new Error("传统招聘月薪不能小于岗位月薪"));
      }
      // 验证通过
      callback();
    },
    async getDetail() {
      let {
        data: { code, data },
      } = await service.detail({
        serviceId: this.id,
      });
      if (code == 200) {
        this.serviceInfo = data;
        var img = data.imgUrl;
        var arr = [this.serviceInfo.cover].concat(this.serviceInfo.imgUrl);
        arr = arr.filter((res) => res != null);
        arr.forEach((res) => {
          var obj = {
            url: res,
            name: res,
            status: 1,
          };
          this.fileList.push(obj);
        });
        this.getAllTags();
      }
    },
    submit() {
      this.$refs.serviceInfo.validate((valid) => {
        if (valid) {
          let serviceInfo = this.serviceInfo;
          let skills = serviceInfo.thirdSkillTags.concat(
            serviceInfo.customTags
          );
          if (skills.length) {
            this.update();
          } else {
            this.$message.error("类目三级不能为空");
          }
        } else {
          return false;
        }
      });
    },
    async update() {
      let obj = this.serviceInfo;
      if (this.fileList && this.fileList.length) {
        this.serviceInfo.imgUrl = this.formatImgs(this.fileList);
      } else {
        this.$message.error("最少上传 1 张服务封面");
        return;
      }
      if (this.fileList.length > 9) {
        this.$message.error("最多上传 9 张服务封面");
        return
      }
      if (this.serviceInfo.chargingWay != 1) {
        this.serviceInfo.versions = [
          {
            deliverable: this.serviceInfo.deliverable,
            deliveryCycle: 1,
            freeRevisions: 1,
            price: this.serviceInfo.hourlyRate,
            version: 1,
          },
        ];
      }
      // var arr = []
      // this.fileList.forEach(res => {
      //   arr.push(res.url)
      // })
      var arg = {
        serviceId: this.id ? this.id : "",
        serviceTitle: this.serviceInfo.serviceTitle,
        name: this.serviceInfo.name,
        serviceContent: this.serviceInfo.serviceContent,
        customerNeeds: this.serviceInfo.customerNeeds,
        tid: this.serviceInfo.talentId,
        cover: this.serviceInfo.cover,
        jobCate: this.serviceInfo.jobCate,
        skillTags: this.serviceInfo.skillTags,
        thirdSkillTags: this.serviceInfo.thirdSkillTags,
        hourlyRate: this.serviceInfo.hourlyRate,
        projectPrice: this.serviceInfo.hourlyRate,
        versions: this.serviceInfo.versions,
        imgUrl: this.serviceInfo.imgUrl,
        chargingWay: this.serviceInfo.chargingWay,
        deliverable: this.serviceInfo.deliverable,
      };
      console.log(arg)
      let {
        data: { code },
      } = await service[this.action](arg);
      if (code == 200) {
        let vue = this;
        this.$message({
          showClose: false,
          message: "保存成功",
          type: "success",
          onClose() {
            window.location.href = `/services`;
            // this.getDetail()
          },
        });
      }
    },
    async getAllTags() {
      let {
        data: { code, data },
      } = await api.workCateList.getAllTags({
        publisherIdEnc: this.serviceInfo.publisherIdEnc,
      });
      if (code == 200) {
        this.cates = data.workCategory;
        this.customTags = data.customTags;
      }
    },
    formatCustomTags(customTags) {
      customTags.forEach((item) => {
        item.isCustom = true;
      });
      return customTags;
    },
    getCatesById(id) {
      let arr = [];
      this.cates.forEach((item) => {
        if (item.parentId === id) {
          var obj = {
            icon: item.icon,
            id: item.id,
            name: item.name,
            parentId: item.parentId,
          };
          arr.push(obj);
        }
      });
      return arr;
    },
    cateChange1(data) {
      console.log(data);
    },
    cateChange(name) {
      switch (name) {
        case "jobCate":
          this.serviceInfo["skillTags"] = [];
          this.serviceInfo["thirdSkillTags"] = [];
          break;
        case "skillTags":
          this.delThirdCates();
          break;
        default:
      }
    },
    inArr(id, array) {
      let isIn = false;
      array.forEach((item) => {
        if (item.id === id) {
          isIn = true;
        }
      });
      return isIn;
    },
    delThirdCates() {
      let thirdCates = this.serviceInfo.thirdSkillTags;
      let newArr = [];
      thirdCates.forEach((item) => {
        if (this.inArr(item.parentId, this.serviceInfo.skillTags)) {
          newArr.push(item);
        }
      });
      this.serviceInfo.thirdSkillTags = newArr;
    },
  },
};
</script>
<style scoped>
.demo-form-inline {
  width: 640px;
}

.service-detail {}
</style>



// WEBPACK FOOTER //
// src/views/service/detail.vue